import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import { emptyFragment } from '@execonline-inc/execonline-ui';
import Currency from '../../../../../../Currency';
import { ExperienceOverviewChip } from '../../../Common';

interface Props {
  price: Maybe<number>;
}

function ExperiencePrice({ price }: Props) {
  return price
    .map((price) => {
      const priceInDollars = price / 100;
      const formattedPrice = priceInDollars.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: priceInDollars % 1 === 0 ? 0 : 2,
      });
      return (
        <ExperienceOverviewChip ariaLabel={`Price: ${formattedPrice}`}>
          <Currency priceInDollars={priceInDollars} />
        </ExperienceOverviewChip>
      );
    })
    .getOrElse(emptyFragment);
}

export default observer(ExperiencePrice);
